import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "DocumentEdit" })
export default class DocumentEdit extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = true;
    public isLoadingForm: boolean = false;
    public fileSharingDocuments: any[] = [];
    public formData: any = { fileName: null, category: null, type: null, description: null, tags: [], languages: [], allowedRoles: [] };
    public types: any[] = [];
    public tags: any[] = [];
    public categories: any[] = [];
    public languages: any[] = [];
    public allowedRoles: any[] = [];
    public validationErrors: any[] = [];

    get userContext() {
        return this.$store.getters["accountUserStore/userContext"];
    }

    get isDocumentEditVisible() {
        return this.$store.getters["myFileSharingStore/isDocumentEditVisible"];
    }

    get documentCodes() {
        return this.$store.getters["myFileSharingStore/documentCodes"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Watch("isDocumentEditVisible") async onDocumentEditVisibleUpdate(newValue: boolean) {
        if (newValue) {
            await this.getData();
            document.body.classList.add("overflow");
            (<any>this).$refs.documentedit.classList.add("show");
        } else {
            document.body.classList.remove("overflow");
            (<any>this).$refs.documentedit.classList.remove("show");
        }
    }

    public async getData() {
        this.isLoading = true;

        const result = (await Axios.post(this.routes.MyBremboPartsFileSharingManagement_GetDocumentEditData, { documentCodes: this.documentCodes })).data;

        this.fileSharingDocuments = result.fileSharingDocuments;

        if (this.fileSharingDocuments.length === 1) {
            this.formData.fileName = result.fileSharingDocuments[0].fileName;
            this.formData.category = result.fileSharingDocuments[0].category;
            this.formData.type = result.fileSharingDocuments[0].type;
            this.formData.description = result.fileSharingDocuments[0].description;
            this.formData.languages = result.fileSharingDocuments[0].languages;
            this.formData.allowedRoles = result.fileSharingDocuments[0].allowedRoles;
            this.formData.tags = result.fileSharingDocuments[0].tags;
            this.types = result.types;
            this.tags = result.tags;
            this.allowedRoles = result.allowedRoles;
            this.languages = result.languages;
            this.categories = result.categories;
        }

        this.isLoading = false;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingForm = true;

        this.formData.documentCodes = this.documentCodes;

        try {
            await Axios.post(this.routes.MyBremboPartsFileSharingManagement_DocumentEdit, this.formData);

            location.reload();
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoadingForm = false;
    }

    public setAllowedRoles() {
        if (this.formData.allowedRoles.length === 0) {
            this.formData.allowedRoles = [this.allowedRoles[0].value];
        } else {
            this.formData.allowedRoles = [];
        }
    }

    public setCategory(category: string): void {
        this.formData.category = category;
    }

    public closeDialog() {
        this.$store.commit("myFileSharingStore/setDocumentEditVisible", false);
        this.$store.commit("myFileSharingStore/setDocumentCodes", []);
        this.fileSharingDocuments = [];
        this.formData = { fileName: null, category: null, type: null, description: null, tags: [], languages: [], allowedRoles: [] };
        this.isLoading = false;
        this.isLoadingForm = false;
        this.types = [];
        this.tags = [];
        this.allowedRoles = [];
        this.languages = [];
        this.validationErrors = [];
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
}